import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TreatmentPlanningComponent } from './treatment-planning.component';
import { ToothPickerModule } from '../tdo-shared/tooth-picker/tooth-picker.module';

import {
  DxBoxModule,
  DxSelectBoxModule,
  DxTabPanelModule,
  DxListModule,
  DxButtonModule,
  DxFormModule,
  DxTextBoxModule,
  DxDropDownButtonModule,
  DxSpeedDialActionModule,
  DxCheckBoxModule,
  DxDateBoxModule,
  DxPopupModule, DxNumberBoxModule
} from 'devextreme-angular';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';

import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TreatmentReportComponent } from './treatment-report/treatment-report.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {FormsFormModule} from '../forms/forms-form/forms-form.module';
import {SignaturePadModule} from '@tdo-inc/tdox-signaturepad/dist/tdox-signaturepad';
import {DirectivesModule} from '../../directives/directives.module';
import {FormsDialogComponent} from '../../dialog/forms-dialog/forms-dialog.component';
import {TdoControlsModule} from '../../tdo-controls/tdo-controls.module';
import { TreatmentPlanApprovalComponent } from './treatment-plan-approval/treatment-plan-approval.component';
import { MatMenuModule } from '@angular/material/menu';


@NgModule({
    declarations: [
        TreatmentPlanningComponent,
        TreatmentReportComponent,
        FormsDialogComponent,
        TreatmentPlanApprovalComponent,
        TreatmentPlanApprovalComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ToothPickerModule,
        DxBoxModule,
        DxSelectBoxModule,
        DxTabPanelModule,
        DxListModule,
        DxButtonModule,
        DxFormModule,
        DxTextBoxModule,
        DxDropDownButtonModule,
        DxSpeedDialActionModule,
        DxCheckBoxModule,
        DxDateBoxModule,
        DxPopupModule,
        MatDividerModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatButtonModule,
        MatIconModule,
        MatSnackBarModule,
        MatProgressBarModule,
        MatFormFieldModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        FormsFormModule,
        DxNumberBoxModule,
        SignaturePadModule,
        MatInputModule,
        MatAutocompleteModule,
        DirectivesModule,
        MatCheckboxModule,
        TdoControlsModule,
        MatMenuModule

    ],
    exports: [
        TreatmentPlanningComponent,
        TreatmentPlanApprovalComponent
    ]
})
export class TreatmentPlanningModule { }
